// @flow
import classNames from 'classnames';
import * as React from 'react';

type Props = {
    children?: React.Node,
    className?: string,
};

const Slide = ({ children, className, ...rest }: Props) => (
    <div className={classNames('slide-content', className)} {...rest}>
        {children}
    </div>
);

export default Slide;
